import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as api from '../../API/index';

/**
 * Async thunk for activation of an equipment
 */
export const activateEquipment = createAsyncThunk(
  'equipment/activateEquipment',
  async (equipment, { rejectWithValue }) => {
    try {
      const Equipment = { ...equipment }
      Equipment.active = true;
      const response = await api.updateEquipment(Equipment._id, Equipment)
      return response.data
    } catch (err) {
      let error = err // cast the error for access
      if (!error.response) {
        throw err
      }
      // We got validation errors, let's return those so we can reference in our component and set form errors
      return rejectWithValue(error.response.data)
    }
  }
)


export const Status = {
  PENDING: "pending",
  CREATED: 'equipment created',
  FAILED: 'failed',
  INACTIVE: 'equipment inactivated',
  ACTIVATED: 'equipment activated',
  RECEIVED: 'data received'
}
const initialState = {
  status: true,
  error: null,
  turbineData: {
    name: null,
    lat: null,
    long: null,
    type: null,
    equipment: {
      marineHelicopterCorridorLights: {
        visible: null,
        state: null,
        amount: null,
        apiUrl: null
      },
      visibilitySensor: {
        visible: null,
        state: null,
        amount: null,
        apiUrl: null
      },
      marineLanterns: {
        visible: null,
        state: null,
        amount: null,
        apiUrl: null
      },
    }
  }
}

export const turbineSlice = createSlice({
  name: 'turbine',
  initialState,
  reducers: {
    select: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.turbineData = action.payload
    },
    unSelect: state => {
      state.turbineData = null;
    },
    newPark: (state, action)=>{
      state.status = action;
    },
    activateEquipmentNarineHelicopterCorridorLights: state => {
      state.turbineData.equipment.marineHelicopterCorridorLights.state = 0;
      state.turbineData.equipment.marineHelicopterCorridorLights.visible = 1;

    },
    inActivateEquipmentNarineHelicopterCorridorLights: state => {
      state.turbineData.equipment.marineHelicopterCorridorLights.state = 1;
      state.turbineData.equipment.marineHelicopterCorridorLights.visible = 0;

    },
    activateEquipmentVisibilitySensor: state => {
      state.turbineData.equipment.visibilitySensor.state = 0;
      state.turbineData.equipment.visibilitySensor.visible = 1;
    },
    inActivateEquipmentVisibilitySensor: state => {
      state.turbineData.equipment.visibilitySensor.state = 1;
      state.turbineData.equipment.visibilitySensor.visible = 0;
    },
    activateEquipmentMarineLanterns: state => {
      state.turbineData.equipment.marineLanterns.state = 0;
      state.turbineData.equipment.marineLanterns.visible = 1;
    },
    inActivateEquipmentMarineLanterns: state => {
      state.turbineData.equipment.marineLanterns.state = 1;
      state.turbineData.equipment.marineLanterns.visible = 0;
    },

    displayHelicopterCorridorLights: (state, action) => {
      state.turbineData.equipment.marineHelicopterCorridorLights.visible = action.payload;
    },
    displayVisibilitySensor: (state, action) => {
      state.turbineData.equipment.visibilitySensor.visible = action.payload;
    },
    displayMarineLanterns: (state, action) => {
      state.turbineData.equipment.marineLanterns.visible = action.payload;
    }


  },
  extraReducers: {
    [activateEquipment.pending]: (state, action) => {
      state.status = Status.PENDING
    },
    [activateEquipment.fulfilled]: (state, { payload }) => {
      state.status = Status.ACTIVATED
      state.selectedEquipment = payload;
    },
    [activateEquipment.rejected]: (state, action) => {
      state.status = Status.FAILED
      if (action.payload) {
        // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error.message
      }
    },
  }
})

export const { select, unSelect, 
  activateEquipmentNarineHelicopterCorridorLights, 
  inActivateEquipmentNarineHelicopterCorridorLights, 
  activateEquipmentVisibilitySensor, 
  inActivateEquipmentVisibilitySensor, 
  activateEquipmentMarineLanterns, 
  inActivateEquipmentMarineLanterns ,
  displayHelicopterCorridorLights,
  displayVisibilitySensor,
  displayMarineLanterns,
  newPark

} = turbineSlice.actions

export default turbineSlice.reducer